import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import { useDialog } from "_shared/_providers/dialogs/dialog";
import EntityMember from "_shared/entity-members/entity-member";
import Guid from "_shared/guids/guid";
import { useGetIndividualsByUserIdsQuery } from "marketplace/individuals/_api/individual-api";
import { getIndividualByUserId } from "marketplace/individuals/_stores/individuals-redux-slice";
import ViewIndividualProfile from "marketplace/individuals/profiles/_views/individual-profile-container";
import { useSelector } from "react-redux";

const StyledLink = styled(Link)(({ theme }) => ({
  alignItems: "center",
  color: theme.palette.common.black,
  cursor: "pointer",
  display: "flex",
  overflow: "hidden",
  textDecoration: "underline",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}));

type CreatorLinkProps = {
  creator: EntityMember;
};

export default function CreatorLink(props: Readonly<CreatorLinkProps>) {
  const { creator } = props;

  const individual = useSelector(getIndividualByUserId(creator.userId));
  const { isLoading: loadingCreator, isError: errorLoadingCreator } = useGetIndividualsByUserIdsQuery(
    { userIds: new Set([creator.userId.value]) },
    { skip: !!individual }
  );

  const { openDialog, closeDialog } = useDialog();

  function openProfileDialog(individualId: Guid) {
    openDialog({
      component: <ViewIndividualProfile individualId={individualId} />,
      contentSxProps: {
        display: "flex",
      },
      MuiProps: {
        fullWidth: true,
        maxWidth: "lg",
      },
      titleStyle: {
        paddingBottom: 0
      },
      onClose: closeDialog,
    });
  }

  if (loadingCreator) return <StyledLink>Loading...</StyledLink>;
  if (errorLoadingCreator) return <StyledLink>Error loading user</StyledLink>;
  if (!individual) return <StyledLink>Unknown user</StyledLink>;

  return (
    <StyledLink
      onClick={(event) => {
        event.stopPropagation();
        openProfileDialog(individual.id);
      }}
    >
      {`${individual.fullName}`}
    </StyledLink>
  );
}
